/**
 * Mouse event handler :
 * - select : click on element
 * - over : mouse over element
 * - out : lick outside surface
 * - drag : start/move/end
 * - resize : start/move/end
 * - move : start/move/end
 * 
 * .Area class on each editable zone
 * .SVG class on each resizable/movable element
 * .drag class on each draggable element
 * */
fx.ns("desktop.common.behaviour", class Mouse extends fx.EventDispatcher{

    constructor(surface)
    {   
        super();

        this._surface = surface;

        this._position = {};

        this.disable();
    }

    get surface(){
        return this._surface;
    }

    /*get moved(){
        return (this._position.down && this._position.up && 
                (this._position.down.x != this._position.up.x || this._position.down.y != this._position.up.y ) )
    }*/

    get down(){
        this._position.isDown = true;
    }

    get moving(){
        this._position.isOver = true;
    }

    get up(){
        this._position.isUp = true;
    }

    get selectedElement()
    {
        this._position.selectedElement;
    }

    set selectedElement(val)
    {
        this._position.selectedElement = val;
    }

    get selectedArea()
    {
        this._position.selectedArea;
    }

    set selectedArea(val)
    {
        this._position.selectedArea = val;
    }

    enable(){
        if (this.enabled)
            return;
            
        super.enable();

        this.on("mousedown", this._mouseDown, window );
        this.on("mousemove", this._mouseMove, window);
        this.on("mouseup", this._mouseUp, window);
        this.on("blur", this._mouseUp, window);
    }

    disable(){

        if (!this.enabled)
            return;

        super.disable();

        this.off("mousedown", this._mouseDown, window);
        this.off("mousemove", this._mouseMove, window );
        this.off("mouseup", this._mouseUp, window);
        
        this.off("blur", this._mouseUp, window);
    }

    _mouseDown(event)
    {
        //if (!fx.dom.parent(event.target, ".Board"))
        if (!fx.dom.parent(event.target, this.surface) && !fx.dom.parent(event.target, ".ContextMenu"))
        {
            this.trigger({type:"select", originalEvent : event});
            return;
        }

        let underElements = this._getUnderElements(event);

        this._position.down = {x : event.clientX, y : event.clientY};
        this._position.isDown = true;
        this._position.isMove = false;
        this._position.isUp = false;
        this._position.dragging = false;
        this._position.moving = false;
        this._position.resizing = false;
        this._position.underElements = underElements;
        /*this._position.selectedElement = underElements.element;
        this._position.selectedArea = underElements.area;*/

        

        
        let e = {originalEvent : event, area : underElements.area, element : underElements.element };

        e.type = "out";
        

        if (!fx.dom.parent(event.target, this.surface))
        {
            this.trigger(e)
            return;
        }
            

        if (fx.dom.parent(event.target, ".ToolBar"))
        {
            // if not in input and textarea, cancel event (so not mouseup)
            if ( !fx.dom.parent(event.target, "input") && fx.dom.parent(event.target, "textarea") )
                event.preventDefault();
            return;
        }

        // start resize
        if (this._position.selectedElement && (fx.dom.parent(event.target, ".anchor")  /*|| fx.dom.parent(event.target, ".border")*/  ))
        {
            this._position.resizing = true;
            e.type = "resize";
            e.state = "start";
            e.element = this._position.selectedElement;
            e.area = this._position.selectedArea;

            this.trigger(e)
        }
        else
        // start drag
        if (fx.dom.parent(event.target, ".drag") && underElements.element && underElements.element.active)
        {
            this._position.dragging = true;
            e.type = "drag";
            e.state = "start";
            this.trigger(e)
        }
        
       
    
    }

    _mouseMove(event)
    {   
        let e = {originalEvent : event };

        let underElements = this._position.underElements ? this._position.underElements : this._getUnderElements(event);

        if (this._position.isDown && !this._position.moving && !this._position.dragging && !this._position.resizing && underElements.element && underElements.element.active && !underElements.element.movableWhenActive)
            return;
        
        if (fx.dom.parent(event.target, ".ToolBar"))
        {
            e.type = "out";
            this.trigger(e);

            // if not in input and textarea, cancel event (so not mouseup)
            if ( !fx.dom.parent(event.target, "input") && fx.dom.parent(event.target, "textarea") )
                event.preventDefault();
            return;
        }

        //let underElements;
        this.moved = (this._position.down && (this._position.down.x != event.clientX || this._position.down.y != event.clientY ) );
        if (this._position && this._position.down && !this._position.moving)
        {
            if (fx.get("settings").gridmode)
                this.moved = (Math.abs(this._position.down.x - event.clientX) >= fx.get("settings").precision ) || (Math.abs(this._position.down.y - event.clientY) >= fx.get("settings").precision);
        }
       
        
        // start move
        if (this._position.isDown && !this._position.moving && !this._position.dragging && !this._position.resizing && this.moved)
        {
            underElements = this._getUnderElements(event);

            if (underElements.element && !underElements.element.hasClass("fixed") )
            {
                this._position.moving = true;
                e.type = "move";
                e.state = "start";
                e.area = underElements.area;
                e.element = underElements.element;
                this.trigger(e)
                
            }
        }

        
        this._position.move = {x : event.clientX, y : event.clientY};
        //this._position.isDown = false;
        this._position.isMove = true;
        this._position.isUp = false;


        if (this._position.dragging)
        {
            e.type = "drag";
            e.state = "action";
        }
        else
        if (this._position.resizing)
        {
            e.type = "resize";
            e.state = "action";
        }
        else
        if (this._position.moving)
        {
            e.type = "move";
            e.state = "action";
        }
        else
        {
            if (!fx.dom.parent(event.target, ".border") && fx.dom.parent(event.target, ".BaseComponent"))
            {
                if (!underElements)
                    underElements = this._getUnderElements(event);
                e.type = "over";
                e.state = "";
                e.area = underElements.area;
                e.element = underElements.element;
            }
        }
        
        if (e.type)
        {
            if(!fx.get("dragging"))
                this.trigger(e);
        }
            

        if ( !e.type ||  ( (this._position.dragging || this._position.resizing /*|| this._position.moving*/) && !this._position.outSent))
        {
            e.type = "out";
            this.trigger(e);

            //this._position.outSent = true;
        }
        
    }

    _mouseUp(event)
    {
        this._position.isDown = false;
        this._position.isMove = false;
        this._position.isUp = true;
        this._position.outSent = false;

       
        if (!this._position.dragging && (fx.dom.parent(event.target, ".ToolBar") || fx.dom.parent(event.target, ".action"))) // TODO : find better solution for .action (BookArea : background and addText)
        {
            // if not in input and textarea, cancel event (so not mouseup)
            if ( !fx.dom.parent(event.target, "input") && fx.dom.parent(event.target, "textarea") )
                event.preventDefault();
        }
        else
        {
            let underElements = this._getUnderElements(event);

            this._position.up = {x : event.clientX, y : event.clientY};

            let e = {type:"select", originalEvent : event, area : underElements.area, element : underElements.element };
        

            if (!this.moved && (!this._position.dragging && !this._position.resizing && !this._position.moving) && fx.dom.parent(event.target, this.surface) /*fx.dom.parent(event.target, ".Board")*/)
            {
                this.trigger(e);
                this._position.selectedElement = underElements.element;
                this._position.selectedArea = underElements.area;
            }
        
            if (this._position.resizing)
            {
                e.type = "resize";
                e.state = "end";
                this.trigger(e);
            }
            else
            if (this._position.dragging)
            {
                e.type = "drag";
                e.state = "end";
                this.trigger(e);
            }
            else
            if (this._position.moving)
            {
                e.type = "move";
                e.state = "end";
                this.trigger(e);
            }


            //if (e.type:"select"

            let elt = fx.dom.parent(event.target, "div[contenteditable=true]");
            if (!elt)
            {
                event.preventDefault();
                event.stopPropagation();
            }
        }
        
        
        this._position.dragging = false;
        this._position.moving = false;
        this._position.resizing = false;

        this._position.move = null;
        this._position.down = null;
        this._position.up = null;
        this._position.underElements = null;
        
    }



    _getUnderElements(event)
    {
        
        let areaUI;
        let elementUI;

        /*if (!fx.dom.parent(event.target, ".border"))
        {
            areaUI = fx.dom.parent(event.target, ".Area");
            elementUI = fx.dom.parent(event.target, ".BaseComponent");
        }
        else*/
        //{
            let elements = fx.graphics.underElements(event);

            /*let x = parseInt(event.pageX);
            let y = parseInt(event.pageY);

            if (Number.isInteger(x) &&  Number.isInteger(y))
            {
                if (document.elementsFromPoint) // Chrome
                    elements = document.elementsFromPoint(x, y);
                else
                if (document.elementFromPoint)
                {
                    let previousPointerEvents = [], current, i, d;

                    // get all elements via elementFromPoint, and remove them from hit-testing in order
                    while ((current = document.elementFromPoint(x, y)) && elements.indexOf(current) === -1 && current != null) {

                        // push the element and its current style
                        elements.push(current);
                        previousPointerEvents.push({
                            value: current.style.getPropertyValue('pointer-events'),
                            priority: current.style.getPropertyPriority('pointer-events')
                        });

                        // add "pointer-events: none", to get to the underlying element
                        current.style.setProperty('pointer-events', 'none', 'important');

                        if (fx.dom.parent(current, ".BaseComponent"))
                            break;
                    }

                    // restore the previous pointer-events values
                    for (i = previousPointerEvents.length; d = previousPointerEvents[--i];) {
                        elements[i].style.setProperty('pointer-events', d.value ? d.value : '', d.priority);
                    }
                }
                else
                if (document.msElementsFromRect && document.msElementsFromRect(x, y, 1, 1)){ // IE
                    let nodes = document.msElementsFromRect(x, y, 1, 1)
                    for(let i = nodes.length; i--; elements.unshift(nodes[i]));
                }

                if (elements.length > 0)
                {
                    for(let i = 0; i < elements.length; i++)
                    {
                        if (fx.dom.parent(elements[i], ".loading"))
                            break;

                        if (fx.dom.parent(elements[i], ".BaseComponent") || fx.dom.parent(elements[i], ".Stage")) 
                        {
                                areaUI = fx.dom.parent(elements[i], ".Area") || fx.dom.parent(elements[i], ".Stage");
                                elementUI = fx.dom.parent(elements[i], ".BaseComponent");
                                break;
                        }
                    }
                }
            //}
        }*/

        if (elements.length > 0)
        {
            for(let i = 0; i < elements.length; i++)
            {
                if (fx.dom.parent(elements[i], ".loading"))
                    break;

                if (fx.dom.parent(elements[i], ".BaseComponent") || fx.dom.parent(elements[i], ".Stage")) 
                {
                        areaUI = fx.dom.parent(elements[i], ".Area") || fx.dom.parent(elements[i], ".Stage");
                        elementUI = fx.dom.parent(elements[i], ".BaseComponent");
                        break;
                }
            }
        }
    //}

        //if (areaUI || elementUI)
        //{
            this._position.previousArea = areaUI ? this.surface.getArea(areaUI.id) : null;
            this._position.previousElement = (elementUI && this._position.previousArea) ? this._position.previousArea.getElement(elementUI.getAttribute("id")) : null;
        //}

        return {area : this._position.previousArea, element : this._position.previousElement};

    }

    destroy()
    {
        super.destroy();
        
        this.disable();
    }
});
        